/**
 * Creates a Map from an array of items, using a function to determine each item's key.
 * @param items The array of items to convert into a map.
 * @param keyFn A function that returns the key for each item.
 * @returns A Map where keys are derived from items and values are the items themselves.
 */
export function createLookupMap<T, K extends keyof any>(
  items: T[],
  keyFn: (item: T) => K,
): Map<K, T> {
  return new Map(items.map((item) => [keyFn(item), item]));
}
